import React from 'react'
import { useSidePanel } from './SidePanelProvider'
import cx from 'classnames'
import { platformTransitionStyle } from '../../../../shared/helpers'

import type { MainContentProps } from './types'

export const MainContent = ({ children }: MainContentProps) => {
  const {
    isSidePanelOpened,
    hasMainContentFullHeight,
    closeWithoutVerticalTranslate,
    withoutTransitions,
  } = useSidePanel()

  return (
    <div
      className={cx('main-content', {
        'main-content--full-height': hasMainContentFullHeight,
        'main-content--side-panel-closed': !isSidePanelOpened,
        'main-content--close-without-vertical-translate':
          !isSidePanelOpened && closeWithoutVerticalTranslate,
      })}
      style={{
        transition: `${
          withoutTransitions
            ? 'none'
            : platformTransitionStyle('transform 500ms linear')
        }`,
      }}
    >
      {children}
    </div>
  )
}

export default MainContent
